import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AjaxService } from './ajax.service';
import * as _ from 'underscore';
import { Utility } from '../shared/utility/utility';
import { policiesTypes } from '../shared/utility/config';
import { Observable } from 'rxjs';
import * as $ from 'jquery';
import { EmitterService } from './emitter.service';
@Injectable({
  providedIn: 'root'
})
export class PoliciesVersionService {
  userPolicies: any
  configuredPolicies: any;
  changedPolicies:any=[];
  userPoliciesGroupByType;
  configuredPoliciesGroupByType;
  clonedPolicieTypes;

  isVersionUptoDate;
  constructor(
    private ajaxService: AjaxService,
    private utils:Utility,
    private emitterService: EmitterService
  ) {
    this.userPolicies = this.getUserPolicies();
    this.userPoliciesGroupByType = this.utils.getGroupBy(this.userPolicies, 'policyType');
    this.clonedPolicieTypes = policiesTypes;
    this.emitterService.updateLoginStatus$.subscribe((status)=>{
      if(!status) {
        this.userPolicies = undefined;
        this.configuredPolicies = undefined;
        this.userPoliciesGroupByType = {};
        this.configuredPoliciesGroupByType = {};
        this.changedPolicies = [];
        this.isVersionUptoDate = false;
      }
    })
   }


  getUserPolicies() {
    return this.userPolicies;
  }

  setUserPolicies(policies) {
    this.userPolicies = policies;
  }

  getConfiguredPolicies() {
    return this.configuredPolicies
  }

  setConfiguredPolicies(policies) {
    this.configuredPolicies = policies;
  }

  getPolicies(): Observable<any> {
     return this.ajaxService.getPolicies().pipe(map(data=>{
       if(data && data['status'] === 'SUCCESS'){
         this.configuredPolicies=data['policyConfigs'];
       }
       return data
     }));
  }

  getUserPolicyDetails(): Observable<any> {
    return this.ajaxService.getUserPolicyDetails().pipe(map(data => {
      if (data && data['status'] === 'SUCCESS') {
        this.userPolicies = data['policies'];
      }
      return data;
    }));
  }

  getAcceptedPoliciesPayload(policyTypes, configuredPolicesData) {
    let policiesTypes: Array<string> = policyTypes
    let configuredPoliciesGroupByType = _.groupBy(configuredPolicesData, "policyType");
    let acceptedPolicies = Object.values(policiesTypes).map(policy => {
      return {
        policyType: policy['type'],
        policyVersionId: this.getPoliceVersion(configuredPoliciesGroupByType, policy['type']),
        policyAccepted: true
      }
    });
    return acceptedPolicies;
  }

  getPoliceVersion(configuredPoliciesGroupByType, type) {
    if (configuredPoliciesGroupByType && configuredPoliciesGroupByType) {
      if (configuredPoliciesGroupByType && configuredPoliciesGroupByType[type]) {
        return configuredPoliciesGroupByType[type][0].policyVersionId;
      }
    }
    return '1.0';
  }
  checkPolociesInfo(){
    if(this.configuredPolicies && !_.isEmpty(this.configuredPolicies) && this.userPolicies && this.userPolicies.length){
      this.configuredPoliciesGroupByType = _.groupBy(this.configuredPolicies, "policyType");
      this.userPoliciesGroupByType = this.utils.getGroupBy(this.userPolicies, 'policyType');
      this.doVersionCheck();
    }else{
      this.getPolicies().subscribe((res)=>{
        if(res["status"] =="SUCCESS"){
          this.configuredPolicies = res["policyConfigs"];
          if(this.configuredPolicies && this.configuredPolicies.length){
            this.configuredPoliciesGroupByType = _.groupBy(this.configuredPolicies, "policyType");
          this.getUserPolicyDetails().subscribe((data)=>{
            if(data["status"]=="SUCCESS"){
              this.userPolicies = data['policies'];
              if(data['policies'] && data['policies'].length){
                this.userPoliciesGroupByType = this.utils.getGroupBy(this.userPolicies, 'policyType');
                this.doVersionCheck();
              }else{
                this.isVersionUptoDate = false;
                this.utils.openModal("estoniaLicenceModal");
              }
            }
          })
          }
        }
       
       
       })
    }
  }
  doVersionCheck(isPolicyUpdate= false, data= null) {
    this.changedPolicies=[];
    let isUserPoliciesAvailable = Object.keys(this.userPoliciesGroupByType).length > 0 || false;
    let isConfiguredPoliciesAvailable = Object.keys(this.configuredPoliciesGroupByType).length > 0 || false;

    Object.values(this.clonedPolicieTypes).forEach(policy => {
      let version = 0;
      if(isConfiguredPoliciesAvailable && this.configuredPoliciesGroupByType && !(_.isEmpty(this.configuredPoliciesGroupByType)) && this.configuredPoliciesGroupByType[policy['type']]){
        this.configuredPoliciesGroupByType[policy['type']].filter((policyConfigured) =>{
            if(parseFloat(policyConfigured["policyVersionId"]) > version){
                 version = parseFloat(policyConfigured["policyVersionId"]);
            }
        })
      }
      if(version > 0){
        this.configuredPoliciesGroupByType[policy['type']] =  this.configuredPoliciesGroupByType[policy['type']].filter((policyConfigured) =>{
          if(parseFloat(policyConfigured["policyVersionId"]) === version){
               return policyConfigured;
          }
      })
      }
      if( isConfiguredPoliciesAvailable && this.configuredPoliciesGroupByType[policy['type']] && !this.userPoliciesGroupByType[policy['type']]){
        this.changedPolicies.push(policy);
      }
      if (isUserPoliciesAvailable && isConfiguredPoliciesAvailable && this.userPoliciesGroupByType && this.configuredPoliciesGroupByType && !(_.isEmpty(this.userPoliciesGroupByType)) &&
        this.userPoliciesGroupByType[policy['type']] && this.configuredPoliciesGroupByType[policy['type']] &&
        (this.userPoliciesGroupByType[policy['type']][0]['policyVersionId'] !== this.configuredPoliciesGroupByType[policy['type']][0]['policyVersionId'] )||(!(_.isEmpty(this.userPoliciesGroupByType)) && !this.userPoliciesGroupByType[policy['type']][0]['policyAccepted'])) {
        this.changedPolicies.push(policy);
      }
    });

    if (this.changedPolicies.length === 0) {
       this.isVersionUptoDate = true;
    } else {
      this.isVersionUptoDate = false;
      if(isPolicyUpdate){
        this.updatePolociesInfo(data);
      }else{
        setTimeout(()=>{
          this.utils.closeModal("estoniaLicenceModal");
        this.utils.openModal("estoniaLicenceModal");
        },200)
      }
    }
  }
  updatePolocies(isForce=false, isEstoniaPopupFlow?) {
    this.utils.closeModal("estoniaLicenceModal");
    // Adding below code to prevent unexpected behaviour of scrolling at the time of deposit.
    if($("#pnpDepositModal") && !isEstoniaPopupFlow){
      $('body').addClass("modal-open");
    }
    if(this.configuredPolicies && !isForce){
      let data = this.sendNewUpdatedPolicy();
     this.updatePolociesInfo(data);
    }else{
      this.getPolicies().subscribe((polInfo)=>{
        this.configuredPolicies = polInfo["policyConfigs"];
        this.configuredPoliciesGroupByType = _.groupBy(this.configuredPolicies, "policyType");
        let data = this.sendNewUpdatedPolicy();
        this.doVersionCheck(true, data)
      })
    }
    
  }
  sendNewUpdatedPolicy(isRegistration = false){
    this.configuredPoliciesGroupByType = _.groupBy(this.configuredPolicies, "policyType");
      let version = 0;
      this.configuredPolicies.filter((policyConfigured) =>{
        if(parseFloat(policyConfigured["policyVersionId"]) > version){
             version = parseFloat(policyConfigured["policyVersionId"]);
        }
      })
    if(version > 0){
      this.configuredPolicies=  this.configuredPolicies.filter((policyConfigured) =>{
        if(parseFloat(policyConfigured["policyVersionId"]) === version){
             return policyConfigured;
        }
       })
      }
      if(isRegistration){
        return JSON.stringify(this.getAcceptedPoliciesPayload(this.clonedPolicieTypes, this.configuredPolicies))
      }else{
        return { policies: JSON.stringify(this.getAcceptedPoliciesPayload(this.clonedPolicieTypes, this.configuredPolicies))}
      }
     
  }
  updatePolociesInfo(data){
    this.ajaxService.updateUserPolicyDetails(data).then((response)=>{
        if (response && response["status"] == "SUCCESS") {
           this.clearData();
        }
    })
  }
  clearData(){
    this.changedPolicies=[];
    this.userPolicies=undefined;
    this.configuredPolicies=undefined;
  }
}